import isEqual from 'lodash/isEqual';
import {
  NEXT_PAYMENT_RANGES,
  NEXT_PAYMENT_RANGE_DAYS,
  PAYMENT_PLANS_TABS,
  PLAN_FILTER_KEYS,
  TAB_FREQUENCIES,
  TILE_FILTERS,
} from '@/modules/payments/constants/paymentPlans';

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const LABELS_ROOT = 'payment.payment_plans_index';

const FILTER_LABEL_KEYS = {
  [PLAN_FILTER_KEYS.status]: 'filters.status',
  [PLAN_FILTER_KEYS.frequency]: 'filters.frequency',
  [PLAN_FILTER_KEYS.nextPayment]: 'filters.next_payment',
};

const NEXT_PAYMENT_LABEL_KEYS = {
  [NEXT_PAYMENT_RANGES.any]: 'filters.next_payment_any',
  [NEXT_PAYMENT_RANGES.next7Days]: 'filters.next_payment_next_7_days',
  [NEXT_PAYMENT_RANGES.next4Weeks]: 'filters.next_payment_next_4_weeks',
};

export const filterLabelKey = (key) => `${LABELS_ROOT}.${FILTER_LABEL_KEYS[key]}`;

export const filterValueLabelKey = (key, value) => {
  if (key === PLAN_FILTER_KEYS.nextPayment) return `${LABELS_ROOT}.${NEXT_PAYMENT_LABEL_KEYS[value]}`;
  return `${LABELS_ROOT}.${key}.${value}`;
};

export const getActiveFilterKeys = (filters, tab) => Object.values(PLAN_FILTER_KEYS).filter((key) => {
  if (key === PLAN_FILTER_KEYS.nextPayment) return filters[key] !== NEXT_PAYMENT_RANGES.any;
  if (key === PLAN_FILTER_KEYS.frequency && tab !== PAYMENT_PLANS_TABS.plans) return false;
  return filters[key].length > 0;
});

export const getSelectedTiles = (filters) => Object.keys(TILE_FILTERS)
  .filter((tile) => isEqual(filters[TILE_FILTERS[tile].key], TILE_FILTERS[tile].value));

export const buildPaymentPlansQuery = ({ tab, query, filters }, now = new Date()) => {
  const activeKeys = getActiveFilterKeys(filters, tab);
  const frequencies = activeKeys.includes(PLAN_FILTER_KEYS.frequency) ? filters.frequency : TAB_FREQUENCIES[tab];
  const params = {
    page: query.page,
    per_page: query.perPage,
    sort: [`${query.sort.field}:${query.sort.direction}`, query.sort.then].filter(Boolean).join(','),
    frequency_type: frequencies.join(','),
  };

  if (activeKeys.includes(PLAN_FILTER_KEYS.status)) {
    params.status = filters.status.join(',');
  }

  const days = NEXT_PAYMENT_RANGE_DAYS[filters.nextPayment];
  if (days) {
    params.next_payment_date_min = now.toISOString();
    params.next_payment_date_max = new Date(now.getTime() + days * DAY_IN_MS).toISOString();
  }

  return params;
};
